var _PipeClass_a;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export const pipe = (a) => new PipeClass(a);
class PipeClass {
    constructor(a) {
        _PipeClass_a.set(this, void 0);
        __classPrivateFieldSet(this, _PipeClass_a, a, "f");
    }
    chain(fn) {
        return new PipeClass(fn(__classPrivateFieldGet(this, _PipeClass_a, "f")));
    }
    get value() {
        return __classPrivateFieldGet(this, _PipeClass_a, "f");
    }
}
_PipeClass_a = new WeakMap();
